/* eslint-disable import/prefer-default-export */
import { httpStatusCodes } from '../constants/Http';
import { makeProxyRequestWithExpectedErrors } from '../utils/request';
import { rpc } from './helper';

export const checkInfraAllocationAPI = assessmenId =>
  makeProxyRequestWithExpectedErrors({
    expectedError: httpStatusCodes.NOT_FOUND,
    method: 'get',
    url: rpc(`/infra/allocate/${assessmenId}`),
  });
